/* TCR GA4 funnel events. Rides the existing Google & YouTube app tag (G-L4BCE662TW).
   Loads sitewide, self-gates by path, sends nothing on other pages.
   Never sends personal data. Safe no-op if the Google tag is absent. */
(function () {
  'use strict';

  function send(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('event', name, params || {});
    } catch (e) { /* tracking must never break the page */ }
  }

  var path = location.pathname;
  var handle = path.split('/').filter(Boolean).pop() || 'home';

  /* 1) Quiz entry page: quiz_start fires once, on the first click INSIDE the
     reading-quiz widget itself (it is a shadow-DOM component, so the check uses
     the event's composed path). Clicks anywhere else on the page do not count. */
  if (path.indexOf('/pages/starting-point-quiz') === 0) {
    var started = false;
    document.addEventListener('click', function (e) {
      if (started) return;
      var inQuiz = false;
      var eventPath = e.composedPath ? e.composedPath() : null;
      if (eventPath) {
        for (var i = 0; i < eventPath.length; i++) {
          var n = eventPath[i];
          if (n && n.tagName === 'READING-QUIZ') { inQuiz = true; break; }
        }
      } else if (e.target && e.target.closest) {
        inQuiz = !!e.target.closest('reading-quiz');
      }
      if (!inQuiz) return;
      started = true;
      send('quiz_start', { page_handle: handle });
    }, true);
  }

  /* 2) Quiz outcome pages: quiz_complete on load (deterministic), kit CTA clicks. */
  var quizOutcomes = [
    'quiz-learn-sounds', 'quiz-ready-to-start', 'quiz-blending-words',
    'quiz-advanced-sounds', 'quiz-not-ready', 'quiz-advance-reader'
  ];
  if (quizOutcomes.indexOf(handle) > -1) {
    send('quiz_complete', { quiz_result: handle });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/products/"], a[href*="/collections/"], a[href*="/cart"]');
      if (!a) return;
      send('quiz_kit_cta_click', {
        quiz_result: handle,
        link_url: a.getAttribute('href') || '',
        link_text: (a.textContent || '').trim().slice(0, 80)
      });
    }, true);
  }

  /* 3) Webinar pages: play + email-gate submit.
     The workshop pages use Wistia's new player (the wistia-player element from
     fast.wistia.com/player.js), so bind that directly; the legacy _wq binding is
     kept as a fallback for any old-style embeds. The conversion event carries the
     email in its detail; it is deliberately NOT sent. Each event fires once per view. */
  var webinars = { 'toddler-workshop': 'toddler', 'kinder-workshop': 'kinder', 'older-workshop': 'older' };
  if (webinars[handle]) {
    var webinarName = webinars[handle];
    var sentPlay = false;
    var sentGate = false;

    function firePlay() {
      if (sentPlay) return;
      sentPlay = true;
      send('webinar_play', { webinar: webinarName });
    }
    function fireGate() {
      if (sentGate) return;
      sentGate = true;
      send('webinar_gate_submit', { webinar: webinarName });
    }

    function bindNewPlayer(p) {
      if (p.__tcrBound) return;
      p.__tcrBound = true;
      p.addEventListener('play', firePlay);
      p.addEventListener('conversion', fireGate);
    }
    function bindAllNewPlayers() {
      var found = document.querySelectorAll('wistia-player');
      for (var i = 0; i < found.length; i++) bindNewPlayer(found[i]);
    }
    bindAllNewPlayers();
    var tries = 0;
    var poll = setInterval(function () {
      bindAllNewPlayers();
      if (++tries > 15) clearInterval(poll);
    }, 2000);

    window._wq = window._wq || [];
    window._wq.push({
      id: '_all',
      onReady: function (video) {
        video.bind('play', firePlay);
        video.bind('conversion', fireGate);
      }
    });
  }

  /* 4) Homepage and link-in-bio router: which link do people actually tap. */
  if (path === '/' || path.indexOf('/pages/links') === 0) {
    var evName = (path === '/') ? 'home_link_click' : 'links_page_click';
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
      send(evName, {
        link_url: href,
        link_text: (a.textContent || '').trim().slice(0, 80)
      });
    }, true);
  }
})();
